(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parts-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const opposite = { front: 'rear', rear: 'front', left: 'right', right: 'left' };
    const directions = new Set(Object.keys(opposite));
    const stopWords = new Set(['a', 'an', 'and', 'for', 'i', 'my', 'need', 'the', 'to', 'with', 'plus', 'complete', 'replacement', 'replace']);
    const genericPartTerms = new Set(['part', 'parts', 'brake', 'brakes', 'body', 'frame', 'electrical', 'assembly', 'service', 'system', 'systems']);
    const motorServiceTerms = new Set(['bearing', 'cable', 'cap', 'connector', 'cover', 'gasket', 'rubber', 'seal', 'wire', 'wiring']);
    const containsPhrase = (text, phrase) => ` ${text} `.includes(` ${normalize(phrase)} `);
    const aliases = {
      tyre: ['tire', 'tyer'], tyres: ['tire', 'tires', 'tyres'], tire: ['tyre', 'tyer'], tires: ['tyre', 'tyres'],
      pads: ['pad', 'brakepad'], pad: ['pads', 'brakepad'], brake: ['brakes', 'break'], brakes: ['brake', 'breaks'],
      charger: ['charging', 'charge'], controller: ['controler'], suspension: ['suspenion'], throttle: ['throtle'],
      mudguard: ['fender', 'mud guard'], fender: ['mudguard'], motor: ['wheel motor'], display: ['screen', 'dashboard']
    };
    const categoryTerms = {
      brakes: 'brake',
      tyres_wheels: 'tyre wheel',
      electrical: 'electrical',
      battery_charging: 'battery charger',
      motor_drive: 'motor drive',
      suspension_steering: 'suspension steering',
      body_frame: 'body frame',
      controls_display: 'controls display',
      lighting: 'light',
      fasteners_bearings: 'fastener bearing',
      accessories: 'accessory',
      unknown: ''
    };
    const assistantApiBase = (value) => {
      try {
        const rawValue = String(value || '').trim();
        if (!rawValue) return '';
        const url = new URL(rawValue, window.location.origin);
        const localHttp = url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
        if ((url.protocol !== 'https:' && !localHttp) || url.search || url.hash) return '';
        return url.toString().replace(/\/+$/, '');
      } catch {
        return '';
      }
    };

    class PartsFinder {
      constructor(root) {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        this.root = root;
        this.form = root.querySelector('[data-parts-finder-form]');
        this.status = root.querySelector('[data-parts-finder-status]');
        this.discovery = root.querySelector('[data-parts-finder-discovery]');
        this.results = root.querySelector('[data-parts-finder-results]');
        this.addButton = root.querySelector('[data-parts-finder-add]');
        this.cartMessage = root.querySelector('[data-parts-finder-cart-message]');
        this.searchButton = root.querySelector('[data-parts-finder-search]');
        this.modelInput = root.querySelector('[name="model"]');
        this.modelList = root.querySelector('[data-parts-model-list]');
        this.requestInput = root.querySelector('[name="request"]');
        this.clarifications = root.querySelector('[data-parts-clarifications]');
        this.botField = root.querySelector('[name="website"]');
        this.items = [];
        this.catalogItems = new Map();
        this.models = [];
        this.searchGeneration = 0;
        this.activeSearchController = null;
        this.assistantApiUrl = assistantApiBase(root.dataset.assistantApiUrl);
        this.assistantSession = null;
        this.assistantSessionPromise = this.assistantApiUrl ? this.createAssistantSession().catch(() => null) : Promise.resolve(null);
        this.restoredFromUrl = false;
        this.loadModels().then(() => this.restoreSearchFromUrl()).catch(() => []);
        this.modelInput.addEventListener('input', () => this.modelInput.setCustomValidity(''));
        this.requestInput.addEventListener('input', () => this.showClarifications());
        this.form.addEventListener('submit', (event) => this.search(event));
        this.addButton.addEventListener('click', () => this.addBundle());
        root.querySelectorAll('[data-parts-prompt]').forEach((button) => {
          button.addEventListener('click', () => {
            this.requestInput.value = button.dataset.partsPrompt;
            this.showClarifications();
            this.requestInput.focus();
          });
        });
      }

      async fetchWithTimeout(url, options = {}, timeoutMs = 6500) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
        const externalSignal = options.signal;
        const abortFromExternal = () => controller.abort(externalSignal.reason);
        if (externalSignal?.aborted) abortFromExternal();
        else externalSignal?.addEventListener('abort', abortFromExternal, { once: true });
        try {
          const response = await fetch(url, { ...options, signal: controller.signal });
          if (!response.ok) {
            await response.body?.cancel().catch(() => {});
            return { ok: false, status: response.status, json: async () => null, text: async () => '' };
          }
          const body = await response.text();
          return {
            ok: true,
            status: response.status,
            text: async () => body,
            json: async () => JSON.parse(body)
          };
        } finally {
          window.clearTimeout(timeout);
          externalSignal?.removeEventListener('abort', abortFromExternal);
        }
      }

      async createAssistantSession(signal) {
        if (!this.assistantApiUrl) return null;
        const response = await this.fetchWithTimeout(`${this.assistantApiUrl}/v1/session`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
          credentials: 'omit',
          mode: 'cors',
          signal
        }, 4000);
        if (!response.ok) return null;
        const payload = await response.json();
        if (typeof payload.session_token !== 'string' || !payload.session_token) return null;
        this.assistantSession = {
          token: payload.session_token,
          expiresAt: Date.now() + Math.max(1000, Number(payload.expires_in_ms) || 600000) - 1000,
          readyAt: Date.now() + Math.max(0, Number(payload.ready_in_ms) || 0)
        };
        return this.assistantSession;
      }

      async getAssistantSession(refresh = false, signal) {
        if (!this.assistantApiUrl) return null;
        if (!refresh && this.assistantSession && this.assistantSession.expiresAt > Date.now()) {
          this.assistantSessionPromise = null;
          return this.assistantSession;
        }
        if (!refresh && this.assistantSessionPromise) {
          const prefetched = await this.assistantSessionPromise;
          this.assistantSessionPromise = null;
          if (prefetched && prefetched.expiresAt > Date.now()) return prefetched;
        }
        this.assistantSessionPromise = this.createAssistantSession(signal).catch(() => null);
        const session = await this.assistantSessionPromise;
        this.assistantSessionPromise = null;
        return session;
      }

      async waitForAssistantSession(session, signal) {
        const delay = Math.max(0, Number(session?.readyAt) - Date.now());
        if (!delay) return;
        await new Promise((resolve, reject) => {
          const finish = () => {
            signal?.removeEventListener('abort', onAbort);
            resolve();
          };
          const timeout = window.setTimeout(finish, delay);
          const onAbort = () => {
            window.clearTimeout(timeout);
            const error = signal?.reason || Object.assign(new Error('Aborted'), { name: 'AbortError' });
            reject(error);
          };
          if (signal?.aborted) onAbort();
          else signal?.addEventListener('abort', onAbort, { once: true });
        });
      }

      async interpretRequest(selectedModel, userText, signal, retry = true) {
        if (!this.assistantApiUrl) return null;
        const session = await this.getAssistantSession(false, signal);
        if (!session) return null;
        await this.waitForAssistantSession(session, signal);
        if (this.assistantSession?.token === session.token) this.assistantSession = null;
        this.assistantSessionPromise = null;
        const response = await this.fetchWithTimeout(`${this.assistantApiUrl}/v1/interpret`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Parts-Session': session.token
          },
          body: JSON.stringify({
            user_text: userText,
            selected_model: selectedModel,
            approved_models: this.models.slice(0, 120),
            website: this.botField?.value || ''
          }),
          cache: 'no-store',
          credentials: 'omit',
          mode: 'cors',
          signal
        }, 8500);
        if (response.status === 403 && retry) {
          this.assistantSession = null;
          await this.getAssistantSession(true, signal);
          return this.interpretRequest(selectedModel, userText, signal, false);
        }
        if (!response.ok) return null;
        const payload = await response.json();
        return this.validatedInterpretation(payload.result, selectedModel);
      }

      validatedInterpretation(result, selectedModel) {
        if (!result || result.version !== '1' || !Array.isArray(result.requests) || result.requests.length > 8) return null;
        const exactSelectedModel = this.models.find((model) => normalize(model) === normalize(selectedModel));
        const exactResultModel = this.models.find((model) => model === result.model);
        if (exactSelectedModel && exactResultModel !== exactSelectedModel) return null;
        if (!result.clarification || typeof result.clarification.needed !== 'boolean' || !Array.isArray(result.clarification.options)) return null;
        return { ...result, model: exactResultModel || null };
      }

      interpretedRequests(result) {
        return result.requests.map((request) => {
          if (!request || !request.position || !Array.isArray(request.search_terms)) return '';
          const words = [
            request.position.front_rear === 'unspecified' ? '' : request.position.front_rear,
            request.position.side === 'unspecified' ? '' : request.position.side,
            request.part,
            ...request.search_terms,
            request.symptom,
            categoryTerms[request.category] || ''
          ].filter((value) => typeof value === 'string' && value.trim());
          return [...new Set(words.map((word) => word.trim()))].join(' ').slice(0, 240);
        }).filter(Boolean).slice(0, 8);
      }

      showClarifications() {
        const text = normalize(this.requestInput.value);
        const choices = [];
        if (/brake|motor|wheel|tyre|tire|suspension|light|indicator|mudguard|fender/.test(text) && !/front|rear/.test(text)) {
          choices.push(
            { value: 'front', label: this.root.dataset.clarifyFront },
            { value: 'rear', label: this.root.dataset.clarifyRear }
          );
        }
        if (/lever|arm|indicator|light|cover|panel/.test(text) && !/left|right/.test(text)) {
          choices.push(
            { value: 'left', label: this.root.dataset.clarifyLeft },
            { value: 'right', label: this.root.dataset.clarifyRight }
          );
        }
        if (/brake|motor|wheel|suspension|steering/.test(text) && !/assembly|service|pad|bearing|seal|bolt/.test(text)) {
          choices.push(
            { value: 'complete assembly', label: this.root.dataset.clarifyAssembly },
            { value: 'service parts', label: this.root.dataset.clarifyService }
          );
        }
        this.clarifications.replaceChildren(...choices.map((choice) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = choice.label;
          button.addEventListener('click', () => {
            this.requestInput.value = `${this.requestInput.value.trim()} ${choice.value}`.trim();
            this.showClarifications();
            this.requestInput.focus();
          });
          return button;
        }));
        this.clarifications.hidden = choices.length === 0;
      }

      showAssistantClarification(clarification) {
        const question = document.createElement('p');
        question.className = 'parts-finder__clarification-question';
        question.textContent = clarification.question || '';
        const buttons = clarification.options.slice(0, 4).map((choice) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = choice;
          button.addEventListener('click', () => {
            this.requestInput.value = `${this.requestInput.value.trim()} ${choice}`.trim().slice(0, 400);
            this.showClarifications();
            this.requestInput.focus();
          });
          return button;
        });
        this.clarifications.replaceChildren(question, ...buttons);
        this.clarifications.hidden = false;
      }

      async mapWithConcurrency(values, limit, callback, signal) {
        const results = new Array(values.length);
        let cursor = 0;
        const worker = async () => {
          while (cursor < values.length && !signal?.aborted) {
            const index = cursor;
            cursor += 1;
            try {
              results[index] = await callback(values[index], index);
            } catch {
              results[index] = null;
            }
          }
        };
        await Promise.all(Array.from({ length: Math.min(limit, values.length) }, () => worker()));
        return results;
      }

      splitRequests(value) {
        return value
          .split(/\n|,|;|\band\b|\bplus\b/gi)
          .map((item) => item.replace(/^.*?:/, '').trim())
          .filter(Boolean)
          .slice(0, 8);
      }

      score(product, model, request) {
        const candidate = normalize(product.title);
        if (!this.matchesModel(product, model)) return -1;
        const tokens = this.requestTokens(request);
        const systemText = normalize(this.systemTags(product).join(' '));
        const candidateTerms = new Set(`${candidate} ${systemText}`.split(' ').filter(Boolean));
        const directionalTokens = tokens.filter((token) => directions.has(token));
        for (const direction of Object.keys(opposite)) {
          if (!directionalTokens.includes(direction)) continue;
          if (candidateTerms.has(opposite[direction]) || !candidateTerms.has(direction)) return -1;
        }
        const semanticTokens = tokens.filter((token) => !directions.has(token));
        if (!semanticTokens.length) return -1;
        const specificTokens = semanticTokens.filter((token) => !genericPartTerms.has(token));
        if (!specificTokens.length) return -1;
        let score = 0;
        const requestText = normalize(request);
        const requestPhrases = [...new Set([requestText, ...tokens.flatMap((token) => aliases[token] || [])])];
        if (requestPhrases.some((phrase) => candidate === phrase)) score += 80;
        if (requestPhrases.some((phrase) => candidate.startsWith(`${phrase} `) || candidate.startsWith(`${phrase}-`))) score += 50;
        if (requestPhrases.some((phrase) => candidate.includes(phrase))) score += 35;
        if (requestPhrases.some((phrase) => systemText.includes(phrase))) score += 40;
        let matchedTokens = 0;
        let matchedSemanticTokens = 0;
        let matchedSpecificTokens = 0;
        score += tokens.reduce((tokenScore, token) => {
          const alternatives = [token, ...(aliases[token] || [])];
          const titleMatch = alternatives.some((alternative) => containsPhrase(candidate, alternative));
          const systemMatch = alternatives.some((alternative) => containsPhrase(systemText, alternative));
          if (titleMatch || systemMatch) {
            matchedTokens += 1;
            if (!directions.has(token)) matchedSemanticTokens += 1;
            if (specificTokens.includes(token)) matchedSpecificTokens += 1;
          }
          return tokenScore + (titleMatch ? 10 : 0) + (systemMatch ? 8 : 0);
        }, 0);
        if (!matchedSemanticTokens || !matchedSpecificTokens) return -1;
        if (tokens.length && matchedTokens === tokens.length) score += 25;
        if (semanticTokens.includes('motor')) {
          const isMotorServicePart = [...motorServiceTerms].some((term) => candidateTerms.has(term));
          score += isMotorServicePart ? -20 : 100;
        }
        for (const direction of Object.keys(opposite)) {
          if (tokens.includes(direction) && candidate.includes(direction)) score += 20;
        }
        return score;
      }

      sortProducts(products, model, request) {
        return [...products].sort((left, right) => {
          const scoreDifference = this.score(right, model, request) - this.score(left, model, request);
          if (scoreDifference) return scoreDifference;
          const lengthDifference = left.title.length - right.title.length;
          return lengthDifference || left.title.localeCompare(right.title);
        });
      }

      requestTokens(request) {
        return normalize(request).split(' ').filter((token) => token.length > 1 && !stopWords.has(token));
      }

      async findProduct(model, request, signal) {
        const tokens = this.requestTokens(request);
        const searchTerms = [...new Set([
          request,
          ...tokens.flatMap((token) => [token, ...(aliases[token] || [])])
        ])].slice(0, 6);
        const compatibilityTag = normalize(model).startsWith('dualtron ') ? model : `Dualtron ${model}`;
        const queries = [...new Set(searchTerms.flatMap((term) => [
          `tag:"${compatibilityTag}" ${term}`,
          `${model} ${term}`
        ]))].slice(0, 6);
        const responses = await this.mapWithConcurrency(queries, 3, async (searchQuery) => {
          const query = encodeURIComponent(searchQuery);
          const endpoint = `${this.root.dataset.searchUrl}?q=${query}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide`;
          const response = await this.fetchWithTimeout(endpoint, { headers: { Accept: 'application/json' }, signal });
          if (!response.ok) throw new Error('search');
          const payload = await response.json();
          return payload.resources?.results?.products || [];
        }, signal);
        const completedResponses = responses.filter(Array.isArray);
        if (!completedResponses.length) throw new Error('search');
        const products = [...new Map(completedResponses.flat().map((product) => [product.url, product])).values()];
        const ranked = products
          .map((product) => ({ product, score: this.score(product, model, request) }))
          .filter((entry) => entry.score > 0)
          .sort((left, right) => right.score - left.score || left.product.title.length - right.product.title.length || left.product.title.localeCompare(right.product.title));
        if (!ranked.length) return null;
        const suggestion = ranked[0].product;
        const productPath = suggestion.url.split('?')[0];
        const productUrl = `${this.root.dataset.productRoot.replace(/\/$/, '')}${productPath}`;
        const productResponse = await this.fetchWithTimeout(`${productUrl}.js`, { headers: { Accept: 'application/json' }, signal });
        if (!productResponse.ok) throw new Error('product');
        const product = await productResponse.json();
        if (!this.matchesModel(product, model)) return null;
        if (this.score(product, model, request) <= 0) return null;
        const variants = product.variants || [];
        if (variants.length !== 1 || !variants[0].available) return null;
        const [variant] = variants;
        return {
          request,
          title: product.title,
          url: product.url,
          image: product.featured_image,
          price: variant.price,
          model,
          variantId: variant.id
        };
      }

      async loadModels() {
        if (PartsFinder.models) {
          this.setModels(PartsFinder.models);
          return PartsFinder.models;
        }
        const response = await this.fetchWithTimeout(`${this.root.dataset.collectionsUrl}/dualtron-parts`, { headers: { Accept: 'text/html' } });
        if (!response.ok) return [];
        const html = await response.text();
        const filterDocument = new DOMParser().parseFromString(html, 'text/html');
        const models = [...new Set(Array.from(filterDocument.querySelectorAll('input[name="filter.p.m.custom.models_1"]')).map((input) => input.value.trim()).filter(Boolean))].sort((left, right) => left.localeCompare(right));
        PartsFinder.models = models;
        this.setModels(models);
        return models;
      }

      setModels(models) {
        this.models = models;
        this.modelList.replaceChildren(...models.map((model) => {
          const option = document.createElement('option');
          option.value = model;
          return option;
        }));
      }

      restoreSearchFromUrl() {
        if (this.restoredFromUrl) return;
        this.restoredFromUrl = true;
        const params = new URLSearchParams(window.location.search);
        const model = String(params.get('model') || '').trim().slice(0, 80);
        const parts = String(params.get('parts') || '').trim().slice(0, 400);
        const selectedModel = this.models.find((item) => normalize(item) === normalize(model));
        if (!selectedModel || !parts) return;
        this.modelInput.value = selectedModel;
        this.requestInput.value = parts;
        this.showClarifications();
        this.form.requestSubmit();
      }

      persistSearch(model, parts) {
        const url = new URL(window.location.href);
        url.searchParams.set('model', model);
        url.searchParams.set('parts', parts);
        window.history.replaceState(window.history.state, '', url);
      }

      async search(event) {
        event.preventDefault();
        const data = new FormData(this.form);
        const modelInput = String(data.get('model') || '').trim().slice(0, 80);
        const userText = String(data.get('request') || '').trim().slice(0, 400);
        let requests = this.splitRequests(userText);
        if (!modelInput || !requests.length) return;
        this.activeSearchController?.abort();
        const searchController = new AbortController();
        this.activeSearchController = searchController;
        const generation = ++this.searchGeneration;
        let selectedModel = null;
        this.searchButton.disabled = true;
        this.results.hidden = true;
        this.discovery.hidden = true;
        this.status.textContent = this.assistantApiUrl ? this.root.dataset.understanding : this.root.dataset.searching;
        try {
          await this.loadModels();
          if (generation !== this.searchGeneration || searchController.signal.aborted) return;
          selectedModel = this.models.find((item) => normalize(item) === normalize(modelInput));
          const interpretation = this.assistantApiUrl
            ? await this.interpretRequest(selectedModel || modelInput, userText, searchController.signal).catch(() => null)
            : null;
          if (generation !== this.searchGeneration || searchController.signal.aborted) return;
          if (interpretation?.clarification.needed) {
            this.status.textContent = '';
            this.showAssistantClarification(interpretation.clarification);
            return;
          }
          if (['safety_critical', 'out_of_scope'].includes(interpretation?.fallback_reason)) {
            this.items = [];
            this.catalogItems = new Map();
            this.results.hidden = true;
            this.discovery.hidden = true;
            this.renderFallback(true);
            return;
          }
          if (interpretation?.model) {
            selectedModel = this.models.find((model) => model === interpretation.model) || null;
            if (selectedModel) this.modelInput.value = selectedModel;
          }
          const interpreted = interpretation ? this.interpretedRequests(interpretation) : [];
          if (interpreted.length) requests = interpreted;
          if (!selectedModel) {
            this.modelInput.setCustomValidity(this.root.dataset.invalidModel);
            this.modelInput.reportValidity();
            this.status.textContent = '';
            return;
          }
          this.modelInput.setCustomValidity('');
          this.persistSearch(selectedModel, userText);
          this.status.textContent = this.root.dataset.searching;
          const [matches] = await Promise.all([
            this.mapWithConcurrency(requests, 2, (request) => this.findProduct(selectedModel, request, searchController.signal), searchController.signal),
            this.renderDiscovery(selectedModel, requests.join(' '), generation, searchController.signal)
          ]);
          if (generation !== this.searchGeneration || searchController.signal.aborted) return;
          this.items = matches.filter(Boolean);
          this.render();
          this.renderFallback(this.catalogItems.size === 0 || this.items.length < requests.length);
        } catch (error) {
          if (generation === this.searchGeneration && !searchController.signal.aborted) {
            this.status.textContent = this.root.dataset.searchError;
          }
        } finally {
          if (generation === this.searchGeneration && this.activeSearchController === searchController) {
            this.activeSearchController = null;
            this.searchButton.disabled = false;
          }
        }
      }

      renderFallback(show) {
        this.status.replaceChildren();
        if (!show) {
          this.status.textContent = this.root.dataset.resultsReady;
          return;
        }
        const text = document.createElement('span');
        text.textContent = `${this.root.dataset.noMatch} `;
        const link = document.createElement('a');
        const fallbackUrl = this.root.dataset.whatsappUrl || 'https://wa.me/447411071446';
        try {
          const whatsappUrl = new URL(fallbackUrl, window.location.origin);
          if (whatsappUrl.protocol !== 'https:') throw new Error('Invalid WhatsApp URL');
          whatsappUrl.searchParams.set('text', `Dualtron parts help: ${this.modelInput.value.trim()} - ${this.requestInput.value.trim()}`.slice(0, 500));
          link.href = whatsappUrl.toString();
        } catch {
          const whatsappUrl = new URL('https://wa.me/447411071446');
          whatsappUrl.searchParams.set('text', `Dualtron parts help: ${this.modelInput.value.trim()} - ${this.requestInput.value.trim()}`.slice(0, 500));
          link.href = whatsappUrl.toString();
        }
        link.textContent = this.root.dataset.fallback;
        link.target = '_blank';
        link.rel = 'noopener';
        this.status.append(text, link);
      }

      handleize(value) {
        return normalize(value).replace(/\s+/g, '-');
      }

      catalogModelHandle(value) {
        const model = normalize(value).replace(/^dualtron\s+/, '');
        if (model === 'storm ltd') return 'storm-limited';
        if (model === 'storm ltd new') return 'storm-limited-new';
        return this.handleize(model);
      }

      async loadCollection(handle, signal) {
        PartsFinder.collections ||= new Map();
        if (PartsFinder.collections.has(handle)) return PartsFinder.collections.get(handle);
        try {
          const response = await this.fetchWithTimeout(`${this.root.dataset.collectionsUrl}/${handle}/products.json?limit=250`, { headers: { Accept: 'application/json' }, signal });
          if (!response.ok) return [];
          const payload = await response.json();
          const products = payload.products || [];
          PartsFinder.collections.set(handle, products);
          return products;
        } catch {
          return [];
        }
      }

      async loadFirstCompatibleCollection(handles, model, signal) {
        for (const handle of handles) {
          if (signal?.aborted) return [];
          const products = await this.loadCollection(handle, signal);
          const compatible = products.filter((product) => this.isAvailable(product) && this.matchesModel(product, model));
          if (compatible.length) return compatible;
        }
        return [];
      }

      async searchCatalog(query, signal) {
        const endpoint = `${this.root.dataset.searchUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide`;
        try {
          const response = await this.fetchWithTimeout(endpoint, { headers: { Accept: 'application/json' }, signal });
          if (!response.ok) return [];
          const payload = await response.json();
          return payload.resources?.results?.products || [];
        } catch {
          return [];
        }
      }

      async hydrateCatalogProducts(products, signal) {
        const hydrated = await this.mapWithConcurrency(products.slice(0, 40), 4, async (product) => {
          if (!product?.handle) return null;
          try {
            const response = await this.fetchWithTimeout(`${this.root.dataset.productRoot.replace(/\/$/, '')}/products/${product.handle}.js`, { headers: { Accept: 'application/json' }, signal });
            if (!response.ok) return null;
            return response.json();
          } catch {
            return null;
          }
        }, signal);
        return hydrated.filter(Boolean);
      }

      isAvailable(product) {
        return product.available === true || (product.variants || []).some((variant) => variant.available);
      }

      matchesModel(product, model) {
        const exactModel = String(model || '').trim();
        const unbrandedModel = exactModel.startsWith('Dualtron ') ? exactModel.slice(9) : exactModel;
        const approvedTags = new Set([unbrandedModel, `Dualtron ${unbrandedModel}`]);
        return (product.tags || []).some((tag) => !String(tag).startsWith('Systems_') && approvedTags.has(String(tag).trim()));
      }

      systemTags(product) {
        return (product.tags || []).filter((tag) => tag.startsWith('Systems_'));
      }

      priceInMinorUnits(variant) {
        const amount = Number(variant?.price);
        if (!Number.isFinite(amount)) return null;
        return typeof variant.price === 'number' ? Math.round(amount) : Math.round(amount * 100);
      }

      makeCatalogProduct(product, model, catalogItems = this.catalogItems) {
        const row = document.createElement('article');
        row.className = 'parts-finder__catalog-product';
        const variants = product.variants || [];
        const variant = variants.length === 1 && variants[0].available ? variants[0] : null;
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.disabled = !variant;
        checkbox.setAttribute('aria-label', product.title);
        if (variant) {
          const variantId = String(variant.id);
          const price = this.priceInMinorUnits(variant);
          checkbox.dataset.variantId = variantId;
          catalogItems.set(variantId, {
            variantId: variant.id,
            title: product.title,
            price
          });
          checkbox.addEventListener('change', () => this.toggleCatalogItem(variantId, checkbox.checked));
        }
        const imageLink = document.createElement('a');
        imageLink.href = `${this.root.dataset.productRoot.replace(/\/$/, '')}/products/${product.handle}`;
        imageLink.setAttribute('aria-label', product.title);
        const image = document.createElement('img');
        image.src = (typeof product.images?.[0] === 'string' ? product.images[0] : product.images?.[0]?.src) || (typeof product.image === 'string' ? product.image : product.image?.src) || (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.url) || '';
        image.alt = '';
        image.loading = 'lazy';
        imageLink.append(image);
        const copy = document.createElement('div');
        copy.className = 'parts-finder__catalog-copy';
        const title = document.createElement('a');
        title.className = 'parts-finder__catalog-title';
        title.href = imageLink.href;
        title.textContent = product.title;
        const meta = document.createElement('span');
        meta.className = 'parts-finder__catalog-meta';
        meta.textContent = `${model} \u00b7 ${variant ? this.root.dataset.available : this.root.dataset.chooseOptions}`;
        copy.append(title, meta);
        const price = document.createElement('span');
        price.className = 'parts-finder__catalog-price';
        const priceMinor = variant ? this.priceInMinorUnits(variant) : null;
        price.textContent = priceMinor === null ? '' : this.money(priceMinor);
        row.append(checkbox, imageLink, copy, price);
        return row;
      }

      toggleCatalogItem(variantId, checked) {
        this.discovery.querySelectorAll(`input[data-variant-id="${variantId}"]`).forEach((checkbox) => {
          checkbox.checked = checked;
        });
        this.updateSelection();
      }

      makeCatalogGroup(title, products, level, searchQuery, model, catalogItems = this.catalogItems) {
        const group = document.createElement('section');
        group.className = 'parts-finder__catalog-group';
        const heading = document.createElement('div');
        heading.className = 'parts-finder__catalog-heading';
        const headingText = document.createElement(level === 2 ? 'h2' : 'h3');
        headingText.textContent = title;
        const count = document.createElement('span');
        count.textContent = `${products.length} ${this.root.dataset.products}`;
        heading.append(headingText, count);
        const list = document.createElement('div');
        list.className = 'parts-finder__catalog-products';
        products.slice(0, 8).forEach((product) => list.append(this.makeCatalogProduct(product, model, catalogItems)));
        group.append(heading, list);
        if (products.length > 8) {
          const viewAll = document.createElement('a');
          viewAll.className = 'parts-finder__catalog-link';
          viewAll.href = `${this.root.dataset.productRoot.replace(/\/$/, '')}/search?q=${encodeURIComponent(searchQuery)}&type=product`;
          viewAll.textContent = `${this.root.dataset.viewAll} ${products.length}`;
          group.append(viewAll);
        }
        return group;
      }

      async renderDiscovery(model, request, generation, signal) {
        const isStale = () => signal?.aborted || generation !== this.searchGeneration;
        const modelHandle = this.catalogModelHandle(model);
        const brandedModelHandle = modelHandle.startsWith('dualtron-') ? modelHandle : `dualtron-${modelHandle}`;
        let modelProducts = await this.loadFirstCompatibleCollection([
          `spare-parts-for-${brandedModelHandle}`,
          `${modelHandle}-parts`,
          `spare-parts-for-${modelHandle}`
        ], model, signal);
        if (isStale()) return false;
        if (!modelProducts.length) {
          const compatibilityTag = normalize(model).startsWith('dualtron ') ? model : `Dualtron ${model}`;
          const requestTerms = [...new Set([request, ...this.requestTokens(request).flatMap((token) => [token, ...(aliases[token] || [])])])].slice(0, 6);
          const searchedGroups = await this.mapWithConcurrency(requestTerms, 2, (term) => this.searchCatalog(`tag:"${compatibilityTag}" ${term}`, signal), signal);
          if (isStale()) return false;
          const searchedByHandle = new Map(searchedGroups.filter(Array.isArray).flat().map((product) => [product.handle, product]));
          modelProducts = await this.hydrateCatalogProducts([...searchedByHandle.values()], signal);
          if (isStale()) return false;
          modelProducts = modelProducts.filter((product) => this.isAvailable(product) && this.matchesModel(product, model));
        }
        const requestTokens = this.requestTokens(request);
        const assemblyNames = [...new Set(modelProducts.flatMap((product) => this.systemTags(product).map((tag) => tag.slice(8).split(' ')[0])))];
        const assembly = assemblyNames.find((name) => requestTokens.some((token) => normalize(name).includes(token) || token.includes(normalize(name))));
        let categoryProducts = [];
        if (assembly) {
          const assemblyHandle = this.handleize(assembly);
          categoryProducts = await this.loadFirstCompatibleCollection([
            `${assemblyHandle}-parts-for-${brandedModelHandle}`,
            `${modelHandle}-${assemblyHandle}`,
            `${modelHandle}-${assemblyHandle}-parts`
          ], model, signal);
          if (isStale()) return false;
          const searchedProducts = await this.hydrateCatalogProducts(await this.searchCatalog(`tag:"${normalize(model).startsWith('dualtron ') ? model : `Dualtron ${model}`}" ${assembly}`, signal), signal);
          if (isStale()) return false;
          const categoryByHandle = new Map(categoryProducts.map((product) => [product.handle, product]));
          searchedProducts.forEach((product) => {
            if (!categoryByHandle.has(product.handle)) categoryByHandle.set(product.handle, product);
          });
          categoryProducts = [...categoryByHandle.values()];
          categoryProducts = categoryProducts.filter((product) => this.isAvailable(product) && this.matchesModel(product, model));
        }
        if (!categoryProducts.length) {
          categoryProducts = assembly
            ? modelProducts.filter((product) => this.systemTags(product).includes(`Systems_${assembly}`))
            : modelProducts.filter((product) => this.score(product, model, request) > 0);
        }
        const subcategoryPrefix = assembly ? `Systems_${assembly} ` : '';
        const subcategories = new Map();
        if (subcategoryPrefix) {
          categoryProducts.forEach((product) => {
            this.systemTags(product).filter((tag) => tag.startsWith(subcategoryPrefix)).forEach((tag) => {
              const name = tag.slice(subcategoryPrefix.length);
              if (!subcategories.has(name)) subcategories.set(name, []);
              subcategories.get(name).push(product);
            });
          });
        }
        const catalogItems = new Map();
        const fragment = document.createDocumentFragment();
        fragment.append(this.makeCatalogGroup(`${this.root.dataset.allParts}: ${model}`, this.sortProducts(modelProducts, model, request), 2, model, model, catalogItems));
        if (categoryProducts.length) {
          const categoryName = assembly || request;
          fragment.append(this.makeCatalogGroup(`${categoryName} ${this.root.dataset.categoryParts}: ${model}`, this.sortProducts(categoryProducts, model, request), 2, `${model} ${categoryName}`, model, catalogItems));
        }
        if (subcategories.size) {
          const wrapper = document.createElement('section');
          wrapper.className = 'parts-finder__subcategories';
          const title = document.createElement('h2');
          title.textContent = this.root.dataset.subcategories;
          wrapper.append(title);
          [...subcategories.entries()].sort(([left], [right]) => left.localeCompare(right)).forEach(([name, products]) => {
            wrapper.append(this.makeCatalogGroup(name, this.sortProducts(products, model, name), 3, `${model} ${assembly} ${name}`, model, catalogItems));
          });
          fragment.append(wrapper);
        }
        if (isStale()) return false;
        this.catalogItems = catalogItems;
        this.discovery.replaceChildren(fragment);
        this.discovery.hidden = modelProducts.length === 0;
        return true;
      }

      money(amount) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: this.root.dataset.currency || 'GBP'
        }).format(amount / 100);
      }

      render() {
        const suggestedIds = new Set(this.items.map((item) => String(item.variantId)));
        this.discovery.querySelectorAll('input[data-variant-id]').forEach((checkbox) => {
          checkbox.checked = suggestedIds.has(checkbox.dataset.variantId);
        });
        this.results.hidden = this.catalogItems.size === 0;
        this.updateSelection();
      }

      selectedItems() {
        const selectedIds = new Set(Array.from(this.discovery.querySelectorAll('input[data-variant-id]:checked')).map((checkbox) => checkbox.dataset.variantId));
        return [...selectedIds].map((variantId) => this.catalogItems.get(variantId)).filter(Boolean);
      }

      updateSelection() {
        this.addButton.disabled = this.selectedItems().length === 0;
      }

      async addBundle() {
        const selected = this.selectedItems();
        if (!selected.length) return;
        this.addButton.disabled = true;
        this.cartMessage.textContent = '';
        try {
          const response = await this.fetchWithTimeout(this.root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: selected.map((item) => ({ id: item.variantId, quantity: 1 })) })
          }, 8000);
          if (!response.ok) throw new Error('cart');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          this.cartMessage.textContent = this.root.dataset.addSuccess;
          this.addButton.disabled = false;
        } catch (error) {
          this.status.textContent = this.root.dataset.addError;
          this.addButton.disabled = false;
        }
      }
    }

    const initialize = (scope = document) => scope.querySelectorAll('[data-parts-finder]').forEach((root) => new PartsFinder(root));
    const updateOrderCountdown = (scope = document) => {
      const dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'Europe/London' }).format(new Date());
      const dayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(dayName);
      const days = (4 - dayIndex + 7) % 7;
      scope.querySelectorAll('[data-parts-finder]').forEach((root) => {
        const label = days === 0 ? root.dataset.today : `in ${days} ${days === 1 ? root.dataset.day : root.dataset.days}`;
        const element = root.querySelector('[data-parts-order-countdown]');
        if (element) element.textContent = label;
      });
    };
    initialize();
    updateOrderCountdown();
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      updateOrderCountdown(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
